module.exports = __webpack_public_path__ + "media/images/world-map-2bf01df622012a06158d60d8886c4951.png";